import _ from 'underscore';
import Util from './Util';
import Constants from './Constants';
import fallbackConfig from '../fallbackConfig/FallbackConfig.json';
import KillSwitchUtil from './KillSwitchUtil';

const DESKTOP_REQUESTER = 'MCOM-NAVAPP';
const MOBILE_REQUESTER = 'MCOM-MMEW';

const requester = Util.isMobile() ? MOBILE_REQUESTER : DESKTOP_REQUESTER;

export default {

  defaultRecommendationConfig: {
    requester, // MCOM-NAVAPP, MCOM-MMEW
    maxRecommendations: 15,
    productId: -9,
    categoryId: undefined,
    zone: undefined, // "PDP_ZONE_A|PDP_ZONE_B"
    noDefaultRecs: false,
    minimumProductsToDisplay: 1,
  },

  defaultPanelConfig: {
    requester,
    element: undefined, // '#prosPanel'
    zone: undefined, // PDP_ZONE_A, one zone at a time
    pageSize: 6,
    orientation: 'horizontal', // horizontal,vertical
    autoScrollTime: undefined, // time in ms
    viewType: 'carousel',
  },

  redesignPanelExtraConfig: {
    // for mobile devices load lower resolution images
    imageWidth: requester === MOBILE_REQUESTER ? Constants.RESPONSIVE_PROS_WIDTH.SMALL : Constants.RESPONSIVE_PROS_WIDTH.LARGE,
    arrowIconSize: 'small',
    swatch: true,
  },

  redesignProperties: {
    customProductThumbnailEnabled: true,
  },

  properties: {
    fccFallbackEnabled: true,
    fccSortOrder: Constants.FCC_SORT_ORDER.BEST_SELLERS,
    pixelPresentedEnabled: true,
    prosContentEnabled: false,
    prosCollectionsEnabled: false,
    prosCollectionDistProductTypeEnabled: false,
    discovery: false,
  },

  recommendationConfig(_recommendationConfig, properties = {}) {
    const props = {};
    const config = {};
    if (KillSwitchUtil.isTrue('removeFallbackProsZoneEnabled') && fallbackConfig.removeFallback[_recommendationConfig.zone]) {
      props.fccFallbackEnabled = false;
      config.noDefaultRecs = true;
    }
    return {
      config: _.defaults(_recommendationConfig, config, this.defaultRecommendationConfig),
      properties: _.defaults(props, properties, this.properties),
    };
  },

  panelConfig(_panelConfig = {}, properties = {}) {
    const panelConfig = Object.assign({}, _panelConfig);
    const panelProperties = Object.assign({}, properties);

    if (properties.prosZoneRedesignEnabled && panelConfig.orientation !== Constants.CAROUSEL_TYPE.VERTICAL) {
      return {
        config: _.defaults(panelConfig, this.defaultPanelConfig, this.redesignPanelExtraConfig),
        properties: _.defaults(panelProperties, this.properties, this.redesignProperties),
      };
    }

    return {
      config: _.defaults(panelConfig, this.defaultPanelConfig),
      properties: _.defaults(panelProperties, this.properties),
    };
  },
};
